import { observer } from 'mobx-react';
import useCurrentProject from '@hooks/useCurrentProject';
import KidsView from './KidsView';
import StudentsView from './StudentsView';

const SuSScreen = observer(() => {
  const { currentProject } = useCurrentProject();

  if (!currentProject) {
    return <div>Loading...</div>;
  }

  const projectType = currentProject.type;

  if (projectType === 'Nursery') {
    return <KidsView project={currentProject} />;
  } else if (projectType === 'School') {
    return <StudentsView project={currentProject} />;
  } else {
    return 'loading..';
  }
});

export default SuSScreen;
